// Balar Murasu
export const BmSectionName = "balar-murasu";
export const BmSectionTamilName = "பாலர் முரசு";

// GE
export const GeTagTamilName = "பொதுத் தேர்தல் 2025";

// Horoscope
export const HoroscopeSectionName = "horoscope";

// Recent Articles
export const RaSectionName = "recent-articles";

// Video
export const VideoSectionName = "videos";

export const SECTIONS: Record<string, string> = {
  singapore: "singapore",
  tamilnadu: "tamilnadu",
  india: "india",
  world: "world",
  community: "community",
  lifestyle: "lifestyle",
  cinema: "cinema",
  sports: "sports",
  "special-feature": "special-feature",
  literature: "literature",
  youth: "youth",
  editorial: "editorial",
  "top-news": "top-news",
  "maanavar-murasu": "maanavar-murasu",
  advertorial: "advertorial",
  events: "events",
  remedy: "remedy",
  "tm-picks": "tm-picks",
};
